export default "__VITE_ASSET__DK_B6aFc__"